import { Organization } from "chq";
import tagsTypes from "../../constants/tagsTypes";

const getDepartmentFieldCategory = (
  organization?: Organization,
  replaceCategory?: (category: string) => string
) => {
  const labelField = organization?.organizationFields?.find(f => f.table === "departments")?.pluralLabel;
  if (labelField) return labelField?.toLowerCase();

  return replaceCategory ? replaceCategory(tagsTypes.DEPARTMENTS) : tagsTypes.DEPARTMENTS;
};

export default getDepartmentFieldCategory;
